import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../pages/Login/AuthContext.js";
import "../styles/theme/variables.css";
import "./Header.css";

const pageData = {
  "/": { title: "Головна", icon: "home.png" },
  "/other-gurt": { title: "Інші гуртожитки", icon: "otherDom.png" },
  "/acts": { title: "Акти", icon: "acts.png" },
  "/new": { title: "Поселення", icon: "new.png" },
  "/transfer-table": { title: "Переселення", icon: "settle.png" },
  "/goout": { title: "Виселення", icon: "goout.png" },
  "/report": { title: "Звітність", icon: "report.png" },
  "/report-rating": { title: "Звітність (рейтинг)", icon: "reportrating.png" },
  "/instruction": { title: "Інструкція", icon: "instruction.png" },
  "/rating": { title: "Рейтинг", icon: "rating.png" },
};

const adminPages = {
  "/admin-acts": { title: "Керування актами", icon: "adminActs.png" },
  "/admin-rooms": { title: "Керування кімнатами", icon: "adminRooms.png" },
  "/admin-dormitories": {
    title: "Керування гуртожитками",
    icon: "adminDom.png",
  },
  "/allocation/import": { title: "Імпорт рейтингу (ППР)", icon: "rating.png" },
  "/allocation/import-students": { title: "Імпорт студентів", icon: "rating.png" },
  "/allocation/import-revert": { title: "Відкотити останній імпорт", icon: "goout.png" },
  "/allocation/rooms": { title: "Вільні кімнати", icon: "adminRooms.png" },
  "/allocation/plan": { title: "План розподілу", icon: "rating.png" },
};

// Сторінки з параметром у шляху (заголовок за префіксом, у меню їх немає).
const prefixPages = [{ prefix: "/allocation/rooms/", title: "Кімната" }];

const titleByPrefix = (pathname) =>
  prefixPages.find(({ prefix }) => pathname.startsWith(prefix) && pathname.length > prefix.length)?.title;

const isMobile = window.innerWidth <= 768;
const Header = ({ sidebarCollapsed = false, onToggleSidebar }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pageTitle =
    pageData[location.pathname]?.title ||
    adminPages[location.pathname]?.title ||
    titleByPrefix(location.pathname) ||
    "Gurt Systems";

  // Роль і стан входу -- з AuthContext (пам'ять), а не зі сховища браузера.
  const { user, logout } = useAuth();
  const role = user?.role;

  const isAuthenticated = !!user;
  const hasSidebar = isAuthenticated && role !== "zppgy";
  // Кнопка згортання -- лише на десктопі (на мобільному є бургер).
  const canCollapse = hasSidebar && !isMobile && typeof onToggleSidebar === "function";
  const collapsed = canCollapse && sidebarCollapsed;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  // Якщо користувач "zppgy" і не на "/propese-add" - перенаправляємо
  useEffect(() => {
    if (role === "zppgy" && location.pathname !== "/propese-add") {
      navigate("/propese-add");
    }
  }, [role, location.pathname, navigate]);

  return (
    <>
      {/* Верхній хедер */}
      <header
        className="header"
        style={{
          left: !isMobile && hasSidebar && !collapsed ? 235 : 0,
        }}
      >
        <div className="header-left">
          {canCollapse && (
            <button
              type="button"
              className="sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label={collapsed ? "Показати бокове меню" : "Сховати бокове меню"}
              aria-expanded={!collapsed}
              aria-controls="app-sidebar"
              title={collapsed ? "Показати меню" : "Сховати меню"}
            >
              {collapsed ? "☰" : "«"}
            </button>
          )}
          <h2 className="page-Title">{pageTitle}</h2>
        </div>
        {isAuthenticated ? (
          <label onClick={handleLogout} className="logout-block">
            Вихід
            <img
              src="../image/header/exit.png"
              alt="exit"
              className="logout-image"
            />
          </label>
        ) : (
          <></>
        )}
        {/* Бургер тільки на мобільних */}
        {isAuthenticated && isMobile && role !== "zppgy" && (
          <div className="burger" onClick={() => setMenuOpen(!menuOpen)}>
            <div />
            <div />
            <div />
          </div>
        )}
      </header>

      {/* Бокове меню (відображається тільки якщо НЕ "zppgy") */}
      {hasSidebar && (
        <nav
          id="app-sidebar"
          inert={collapsed}
          className={
            isMobile ? `mobile-sidebar ${menuOpen ? "open" : ""}` : `sidebar${collapsed ? " collapsed" : ""}`
          }
        >
          <h2>
            <Link to="/" className="sidebar-title">
              <img
                src={"../image/header/header.png"}
                alt={`Home`}
                className="sidebar-title-image"
              />
              GurtSystems
            </Link>
          </h2>
          {Object.entries(pageData)
            .filter(([path]) => role === "admin" || path !== "/admin")
            .map(([path, { title, icon }]) => (
              <Link
                key={path}
                to={path}
                className="nav-item"
                style={{
                  fontWeight: location.pathname === path ? "bold" : "normal",
                  backgroundColor:
                    location.pathname === path ? "#8AAEE0" : "transparent",
                }}
                onClick={() => isMobile && setMenuOpen(false)} // закриває бургер-меню
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#8AAEE0";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor =
                    location.pathname === path ? "#8AAEE0" : "transparent";
                }}
              >
                <img
                  src={`../image/header/${icon}`}
                  alt={title}
                  className="icon-small"
                />
                {title}
              </Link>
            ))}

          {/* Меню адміна */}
          {role === "admin" && (
            <>
              <hr className="divider" />
              <h3 className="sidebar-subtitle">Адміністрування</h3>
              {Object.entries(adminPages).map(([path, { title, icon }]) => (
                <Link
                  key={path}
                  to={path}
                  className={`nav-item`}
                  onClick={() => isMobile && setMenuOpen(false)}
                  style={{
                    fontWeight: location.pathname === path ? "bold" : "normal",
                    backgroundColor:
                      location.pathname === path ? "#8AAEE0" : "transparent",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#8AAEE0";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor =
                      location.pathname === path ? "#8AAEE0" : "transparent";
                  }}
                >
                  <img
                    src={`../image/header/${icon}`}
                    alt={title}
                    className="icon-small"
                  />
                  {title}
                </Link>
              ))}
            </>
          )}
        </nav>
      )}
    </>
  );
};

export default Header;
